import { render, staticRenderFns } from "./AITSTestAnalysis.vue?vue&type=template&id=318b2da8&"
import script from "./AITSTestAnalysis.vue?vue&type=script&lang=js&"
export * from "./AITSTestAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports